export default __webpack_public_path__ + "static/media/crypto-tracker.8767d0c3.png";